import React from 'react';
import PropTypes from 'prop-types';
import { Surveys } from '../utils/types';
import { SFSurveysTenantLanguage } from "utils/types";
import SurveyView from './SurveyView';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import { setLastViewedSurvey } from "utils/surveys";

export default class SurveyContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    this.getSurveys(false);
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.surveyId !== this.props.surveyId) setLastViewedSurvey(this.props.surveyId);
  }

  getSurveys(forceDefaultSurveyId = false) {
    const surveysURL = `../survey/getSurveys.html`;
    return fetchAuthenticatedJSON(surveysURL, {
      method: 'GET',
      headers: {
        "Pragma": "no-cache",
        "Cache-Control": "no-cache",
        "Expires": "-1"
      }
    })
      .then(json => this.props.onSurveysFetched(json, forceDefaultSurveyId))
      .catch(e => this.props.onFailure(apiErrorMessage(e)))
      .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <SurveyView 
        surveys={this.props.surveys}
        surveyId={this.props.surveyId}
        hasFetched={this.state.hasFetched}
        getStudentFolderLink={this.props.getStudentFolderLink}
        rebindStudentCards={this.props.rebindStudentCards}
        onFailure={this.props.onFailure}
        getSurveys={() => this.getSurveys(true)}
        progressSurveyWords={this.props.progressSurveyWords}
      />
    );
  }
}

SurveyContainer.propTypes = {
  surveys: Surveys,
  surveyId: PropTypes.number,
  onFailure: PropTypes.func.isRequired,
  getStudentFolderLink: PropTypes.func.isRequired,
  rebindStudentCards: PropTypes.func.isRequired,
  onSurveysFetched: PropTypes.func.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage
};
